import { render, staticRenderFns } from "./CmpFooter.vue?vue&type=template&id=2e27b1fc&scoped=true"
import script from "./CmpFooter.vue?vue&type=script&lang=js"
export * from "./CmpFooter.vue?vue&type=script&lang=js"
import style0 from "./CmpFooter.vue?vue&type=style&index=0&id=2e27b1fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27b1fc",
  null
  
)

export default component.exports